import { CMS_ACCESS_ENROLLMENT_FLAG } from "@/constants/AccessProgram";
import { useCommonAllergies } from "@/features/Patient/MedicalRecords/MedicationsAllergies/network/useAllergies";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { useLoadPartners } from "@/network/useLoadPartners";

/**
 * This hook is used for priming RQ caches for data that will be used
 * all over the EMR, and would improve user experience if it's already
 * cached. These should only be queries which are safe to cache for an
 * entire session, i.e. partner data for SVG logos.
 */
export const useEMRPriming = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  useLoadPartners({ enabled });
  useConfigCatFeatureFlag("amazon-structured-allergies");
  useConfigCatFeatureFlag("ehr-ai-feed-enabled");
  useConfigCatFeatureFlag("single-encounter-visits");
  useConfigCatFeatureFlag(CMS_ACCESS_ENROLLMENT_FLAG);
  useCommonAllergies();
};
